import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { formSubmissionIsClosed, submissionPermissions } from "reduxSlices/formSubmissionSlice"
import AddTaskButton from "./AddTaskButton"

const AddTask = ({ openForm }) => {
  const { canAssignTask, canAssignTaskWithSubform } = useSelector(submissionPermissions)

  const submissionIsClosed = useSelector(formSubmissionIsClosed)

  const canAddTask = (canAssignTask || canAssignTaskWithSubform) && !submissionIsClosed

  if (!canAddTask) return null

  return (
    <AddTaskButton openForm={openForm} />
  )
}

AddTask.propTypes = {
  openForm: types.func.isRequired,
}

export default AddTask
